module.exports = __webpack_public_path__ + "img/left1.2177dcb3.svg";